  <div class="pageScroolTela backgroundColor">

  <div class="header-section d-flex align-items-center justify-content-center">
    <h2 class="header-title">CUSTOMER LIFETIME VALUE (CLV)</h2>
  </div>

  <div class="tela">
    <div class="container-fluid">
      <div class="col col-lg-12">

        <div class="card">
          <div class="card-body">
            <div class="caixa">
              <div class="conteudo-caixa-sem-titulo sem-padding">
                <div class="ptb50 d-flex align-items-center">
                  <div class="col col-2">
                    <div class="custom-input">
                      <input type="text" (blur)="validaFocus()" unmask="false" [(ngModel)]="cpfCnpj"
                        placeholder="Digite CPF/CNPJ" (keyup)="doSearch($event)" />
                    </div>
                  </div>
                  <div class="col col-2">
                    <div class="custom-input">
                      <input type="text" (blur)="validaFocus()" unmask="false" placeholder="Digite CHASSI"
                        [(ngModel)]="chassi" />
                    </div>
                  </div>
                  <div class="col col-2">
                    <p-calendar dateFormat="dd/mm/yy" [showIcon]="true" [(ngModel)]="dataInc"
                      placeholder="Data Inicial"></p-calendar>
                  </div>
                  <div class="col col-2">
                    <p-calendar dateFormat="dd/mm/yy" [showIcon]="true" [(ngModel)]="dataFim"
                      placeholder="Data Final"></p-calendar>
                  </div>
                  <div class="col col-4 d-flex justify-content-between">
                    <button translate type="button" class="btn btn-primary mr-2" (click)="clickBuscar()">
                      <i class="fas fa-search"></i>
                    </button>
                    <button translate type="button" class="btn btn-primary mr-2" (click)="limpar()">
                      <i class="fas fa-broom"></i>
                    </button>
                    <div class="col col-8">
                      <div class="custom-input">
                        <input type="text" [disabled]="disabled" placeholder="Cliente" [value]="nomeCliente" />
                      </div>
                    </div>
                    <button pButton class="flex justify-content-center p-button-outlined p-button-secondary p-button-sm" type="button"
                      (click)="abrirExportacaoExcel()" pTooltip="Exportar para Excel">
                      <i class="fa fa-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card fixed-card" *ngIf="mostrarCaption">
          <div class="card-body table-wrapper" #table1Container>
            <p-table [value]="valorDados" styleClass="p-datatable-gridlines" [loading]="loading" scrollHeight="250px"
              scrollable="true" scrollWidth="auto">

              <ng-template pTemplate="caption">
                <div class="p-d-flex justify-content-center">
                  Análise de Vendas no Período
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr class="header-row">
                  <th *ngFor="let column of columns; let i = index" [ngStyle]="{'min-width': '900px', 'width': '230px', 'padding': '10px',
                      'position': i === 0 ? 'sticky' : 'relative',
                      'left': i === 0 ? '0' : 'auto',
                      'margin-left': i === 0 ? '-2px' : '0',
                      'z-index': i === 0 ? '2' : '1',
                      'background-color': 'white'}">
                    {{ column }}
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr [ngClass]="{'highlight-row': row.ITEM === 'TOTAL'}">
                  <td *ngFor="let column of columns; let i = index" [ngStyle]="{'min-width': '950px', 'width': '230px', 'padding': '10px',
                  'position': i === 0 ? 'sticky' : 'relative',
                  'left': i === 0 ? '0' : 'auto',
                  'z-index': i === 0 ? '1' : 'auto',
                  'font-weight': row.ITEM === 'TOTAL' ? 'bold' : 'normal',
                  'background-color': 'white'}">

                    <ng-container
                      *ngIf="column === 'ITEM' || row['ITEM'] !== 'Chassi' && row['ITEM'] !== 'Acessórios' && row['ITEM'] !== 'Roupas' && row['ITEM'] !== 'Seguro' && row['ITEM'] !== '1a Revisão (6 meses/1000km)' && row['ITEM'] !== 'Revisão anual' && row['ITEM'] !== '2a Revisão (10.000/16.000km por ano)' && row['ITEM'] !== '3a Revisão (20.000/32.000 em 2 anos)'">
                      {{ row[column] }}
                    </ng-container>

                    <a *ngIf="column !== 'ITEM' && row['ITEM'] === 'Chassi' && column !== 'Peças/Acessórios/Roupas'" class="link-click"
                      (click)="redirecionaRelatorioVeiculos(column)"
                      pTooltip="Relatório de Veículos (Veículos Vendidos)">
                      Visualizar({{ quantidadePorModelo[column] }})
                    </a>

                    <a *ngIf="column !== 'ITEM' && row['ITEM'] === 'Acessórios'" class="link-click"
                      (click)="redirecionaRmpvDetalhado(column, row)" pTooltip="RMPV - Detalhado">
                      {{ row[column] }}
                    </a>

                    <a *ngIf="column !== 'ITEM' && row['ITEM'] === 'Roupas'" class="link-click"
                      (click)="redirecionaRmpvDetalhado(column, row)" pTooltip="RMPV - Detalhado">
                      {{ row[column] }}
                    </a>

                    <a *ngIf="column !== 'ITEM' && row['ITEM'] === 'Seguro'" class="link-click"
                      (click)="redirecionaRmpvDetalhado(column, row)" pTooltip="RMPV - Detalhado">
                      {{ row[column] }}
                    </a>

                    <a *ngIf="column !== 'ITEM' && row['ITEM'] === '1a Revisão (6 meses/1000km)'" class="link-click"
                      (click)="redirecionaRmpvDetalhado(column, row)" pTooltip="RMPV - Detalhado">
                      {{ row[column] }}
                    </a>

                    <a *ngIf="column !== 'ITEM' && row['ITEM'] === 'Revisão anual'" class="link-click"
                      (click)="redirecionaRmpvDetalhado(column, row)" pTooltip="RMPV - Detalhado">
                      {{ row[column] }}
                    </a>

                    <a *ngIf="column !== 'ITEM' && row['ITEM'] === '2a Revisão (10.000/16.000km por ano)'"
                      class="link-click" (click)="redirecionaRmpvDetalhado(column, row)" pTooltip="RMPV - Detalhado">
                      {{ row[column] }}
                    </a>

                    <a *ngIf="column !== 'ITEM' && row['ITEM'] === '3a Revisão (20.000/32.000 em 2 anos)'"
                      class="link-click" (click)="redirecionaRmpvDetalhado(column, row)" pTooltip="RMPV - Detalhado">
                      {{ row[column] }}
                    </a>

                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr style="position: sticky; bottom: 0; z-index: 1; background-color: white;" *ngIf="mostrarCaption">
                  <td colspan="1" class="p-text-right" [ngStyle]="{'font-weight': 'bold', 'font-size': '16px'}">
                    Total Geral de Vendas no Período
                  </td>
                  <td [ngStyle]="{'font-weight': 'bold', 'font-size': '16px'}">
                    {{ totalGeral | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
                  </td>
                </tr>
              </ng-template>

            </p-table>

          </div>
        </div>

        <div class="card fixed-card" *ngIf="mostrarCaption && exibirLucroPrevisto">
          <div class="card-body table-wrapper">
            <p-table [value]="valorSegundaTabela" [loading]="loading" styleClass="p-datatable-gridlines" scrollHeight="250px"
              scrollable="true" scrollWidth="auto">

              <ng-template pTemplate="caption">
                <div class="p-d-flex justify-content-center">
                  Lucro Previsto no Período
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr class="header-row">
                  <th *ngFor="let column of columns; let i = index" [ngStyle]="{'min-width': '900px', 'width': '230px', 'padding': '10px',
                              'position': i === 0 ? 'sticky' : 'relative',
                              'left': i === 0 ? '0' : 'auto',
                              'z-index': i === 0 ? '2' : '1',
                              'background-color': 'white'}">
                    {{ column }}
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr [ngClass]="{'highlight-row': row.ITEM === 'TOTAL'}">
                  <td *ngFor="let column of columns; let i = index" [ngStyle]="{'min-width': '950px', 'width': '230px', 'padding': '10px',
                  'position': i === 0 ? 'sticky' : 'relative',
                  'left': i === 0 ? '0' : 'auto',
                  'z-index': i === 0 ? '1' : 'auto',
                  'font-weight': row.ITEM === 'TOTAL' ? 'bold' : 'normal',
                  'background-color': 'white'}">

                    <ng-container *ngIf="column === 'Consórcio'">
                      {{ row['percentual'] }}
                    </ng-container>

                    <ng-container *ngIf="column !== 'Consórcio'">
                      {{ isCurrencyColumn(column) ? (row[column] | currency:'BRL':'symbol':'1.2-2':'pt-BR') :
                      row[column] }}
                    </ng-container>

                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr style="position: sticky; bottom: 0; z-index: 1; background-color: white;" *ngIf="mostrarCaption">
                  <td colspan="1" class="p-text-right" [ngStyle]="{'font-weight': 'bold', 'font-size': '16px'}">
                    Total de Lucro Previsto no Período
                  </td>
                  <td [ngStyle]="{'font-weight': 'bold', 'font-size': '16px'}">
                    {{ totalKmGeral | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
                  </td>
                </tr>
              </ng-template>
            </p-table>


          </div>
        </div>

        <div *ngIf="valorDadosBaixo.length > 0 && exibirLucroPrevisto" class="card">
          <div class="card-body">
            <p-table [value]="valorDadosBaixo" styleClass="p-datatable-gridlines" [loading]="loading"
              scrollable="true" scrollWidth="auto">

              <ng-template pTemplate="header">
                <tr class="header-row">
                  <th *ngFor="let column of columns; let i = index" [ngStyle]="{'min-width': '900px', 'width': '230px', 'padding': '10px',
                                  'position': i === 0 ? 'sticky' : 'relative',
                                  'left': i === 0 ? '0' : 'auto',
                                  'z-index': i === 0 ? '2' : '1',
                                  'background-color': 'white'}">
                    {{ column }}
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr [ngClass]="{'highlight-row': row.ITEM === 'CUSTOMER VALUE ATÉ ANO 3'}">
                  <td *ngFor="let column of columns; let i = index" [ngStyle]="{'min-width': '950px', 'width': '230px', 'padding': '10px',
                                  'position': i === 0 ? 'sticky' : 'relative',
                                  'left': i === 0 ? '0' : 'auto',
                                  'z-index': i === 0 ? '1' : 'auto',
                                  'font-weight': row.ITEM === 'CUSTOMER VALUE ATÉ ANO 3' ? 'bold' : 'normal',
                                  'background-color': 'white'}">
                    <ng-container *ngIf="row[column]">
                      {{ row[column] }}
                    </ng-container>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>


        <div *ngIf="!primeiraPesquisa && !mostrarCaption && valorDadosBaixo.length === 0" class="sem-registros card text-muted mt-2">
          Nenhum registro para exibir...
        </div>

        <div class="card">
          <div class="card-body">
            <div class="ranking-titulo">Maiores clientes</div>

            <div *ngIf="rankingErro" class="sem-registros card text-muted mt-2">
              Não foi possível carregar o ranking de clientes.
            </div>

            <p-table *ngIf="!rankingErro" [value]="ranking" [loading]="rankingCarregando" styleClass="p-datatable-gridlines">
              <ng-template pTemplate="header">
                <tr class="header-row">
                  <th>Posição</th>
                  <th>Nome</th>
                  <th>Documento</th>
                  <th>Tipo</th>
                  <th>Total gasto</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-cliente let-rowIndex="rowIndex">
                <tr>
                  <td>{{ rowIndex + 1 }}</td>
                  <td>{{ cliente.nome }}</td>
                  <td>{{ formatarDocumentoRanking(cliente.documento, cliente.tipo) }}</td>
                  <td>{{ formatarTipoRanking(cliente.tipo) }}</td>
                  <td>{{ formatarTotalRanking(cliente.totalGasto) }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5" class="text-muted">Nenhum registro para exibir...</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <!-- <div *ngIf="mostrarCaption" class="sem-registros card text-muted mt-2 d-flex align-items-center justify-content-center">
          <p-progressSpinner *ngIf="loading"></p-progressSpinner>
        </div> -->



      </div>
    </div>
  </div>
</div>

<p-toast key="tl" position="bottom-right"></p-toast>

<p-dialog header="Exportar para Excel" [(visible)]="exibirModalExportacao" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{width: '420px'}">
  <p>O que deseja exportar?</p>
  <div class="exportacao-opcoes">
    <button type="button" class="btn btn-primary" (click)="confirmarExportacao('ranking')">Maiores clientes</button>
    <button type="button" class="btn btn-primary" (click)="confirmarExportacao('cliente')">Dados do cliente</button>
    <button type="button" class="btn btn-primary" (click)="confirmarExportacao('ambos')">Ambos</button>
  </div>
</p-dialog>
